import {
  ProfileUpdateRequest,
  Profile
} from '@bimdata/definitions/dto';
import api from './api';
import { ApiError } from '@bimdata/client/api.error';

async function getProfile(): Promise<Profile> {
  const { data } = await api.get('/profile');
  return data;
}

async function setProfile(body: ProfileUpdateRequest): Promise<Profile | false> {
  if (api.getSession()) {
    const { data } = await api.put('/profile', body);
    return data;
  }
  return false;
}

async function deleteProfile(): Promise<void> {
  await api.delete('/profile');
}


function startEmailVerification(): Promise<void> {
  return api.post('/profile/verify/email/claim');
}

function confirmEmail(code: string): Promise<void> {
  return api.get(`/profile/verify/email/confirm?code=${code}`);
}

function startPhoneVerification(): Promise<void> {
  return api.post('/profile/verify/phone/claim');
}

function confirmPhone(code: string): Promise<void> {
  return api.post(`/profile/verify/phone/confirm`, { code });
}

async function startPasswordReset(): Promise<string | null> {
  const { data } = await api.post(`/profile/pwd/claim`);
  return data.claim;
}

async function checkPasswordResetClaim(claim: string): Promise<boolean> {
  try {
    await api.get(`/profile/pwd/claim/check`, { params: { claim } });
    return true;
  } catch (err) {
    if (err instanceof ApiError && err.code == 404) {
      return false;
    }
    throw err;
  }
}

async function checkEmailVerificationClaim(): Promise<boolean> {
  try {
    await api.get(`/profile/verify/email/check`);
    return true;
  } catch (err) {
    if (err instanceof ApiError && err.code == 404) {
      return false;
    }
    throw err;
  }
}

async function setAvatar(file: File): Promise<string> {
  const fd = new FormData();
  fd.append('file', file);
  await api.post(
    `/profile/avatar`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return URL.createObjectURL(file);
}

async function deleteAvatar(): Promise<void> {
  await api.delete('/profile/avatar');
}

export {
  getProfile,
  setProfile,
  deleteProfile,
  startEmailVerification,
  startPhoneVerification,
  confirmEmail,
  confirmPhone,
  startPasswordReset,
  checkPasswordResetClaim,
  checkEmailVerificationClaim,
  setAvatar,
  deleteAvatar,
};
